import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from 'mdt-core-components/src/helpers/i18n';
import { get, cloneDeep } from 'lodash';
import { themeUpdate } from 'mdt-core-components/src/actions/MeActions';
import {
    MDTlayout,
    MDTScrollButton,
    SnackBar,
    MDTNavigation,
    MDTFooter,
    MDTBreadcrumb,
    MDTLeavePageConfirmation,
    Spinner,
} from 'mdt-core-components';
import SurveyPopup from 'mdt-core-user-components/src/components/surveypopup';
import { MDTApp } from 'mdt-core-components/src/actions/bootAction';
import RightFloatElement from 'mdt-core-user-components/src/components/rightFloatElement';
import Switcher from './Switcher';

export class App extends Component {
    constructor(props) {
        super(props);
        this.navNode = React.createRef();
        this.state = {
            breadCrumbs: [],
        };
    }

    addThemeToApp = (themeId, themesList) => {
        themesList.map((ele) => {
            document.body.classList.remove(ele.id);
        });
        document.body.classList.add(themeId);
    };

    applyTheming = () => {
        const { MDTSetting } = window;
        const defaultTheme =
            MDTSetting.features.defaultTheme === '#{defaultTheme}'
                ? 'electric'
                : MDTSetting.features.defaultTheme;
        const selectedTheme = MDTSetting.themes.find((element) => element.name === defaultTheme);
        selectedTheme?.id && this.addThemeToApp(selectedTheme.id, MDTSetting.themes);
    };

    componentDidMount() {
        const breadCrumbs = cloneDeep(MDTApp.getSetting('breadCrumb.pages', [], false));
        this.setState({
            breadCrumbs,
        });
        this.applyTheming();
    }

    onPageClick = (page) => {
        page.link && this.props.redirectTo(page.link);
    };

    getNavTotalHeight = (element) => {
        if (element && element.current) {
            const DOMNode = ReactDOM.findDOMNode(element.current);

            return DOMNode.firstChild && DOMNode.firstChild.offsetTop
                ? DOMNode.firstChild.offsetHeight + DOMNode.firstChild.offsetTop
                : '';
        }
    };

    render() {
        const { page, pageType } = this.props;
        const { breadCrumbs } = this.state;

        const breadCrumbConfig = {
            breadCrumbs,
            page: pageType ? page + pageType : page,
            homeKey: 'shopHome',
        };
        return (
            <div>
                <div className='MDTApp notranslate'>
                    <I18nextProvider i18n={i18n}>
                        <MDTlayout navigation='new-navigation'>
                            <Spinner
                                {...{
                                    showLoading: this.props.showLoading,
                                    browserSupportsAnimations: true,
                                }}
                            />
                            <div ref={this.navNode}>
                                <MDTNavigation />
                            </div>
                            <div className='mdt-content'>
                                <MDTBreadcrumb
                                    config={breadCrumbConfig}
                                    onPageClick={this.onPageClick}
                                />
                                <Switcher />
                                <SnackBar />
                                <MDTScrollButton scrollStepInPx='50' delayInMs='10' />
                            </div>
                            {this.props.getResourceAccess('VoiceOfCustomer', 'Feature') && (
                                <SurveyPopup />
                            )}
                            <MDTLeavePageConfirmation />
                            <RightFloatElement />
                        </MDTlayout>
                        <MDTFooter />
                    </I18nextProvider>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: get(state, 'meDetails.user', {}),
        page: get(state, 'page', ''),
        pageType: get(state, 'location.query.type', ''),
        showLoading: get(state, 'bootDetails.showSpinner', false),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getResourceAccess: (resource, action) =>
            dispatch(MDTApp.getResourceAccess(resource, action)),
        redirectTo: (pagename) => dispatch({ type: pagename }),
        setThemeChange: (theme) => dispatch(themeUpdate(theme)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
